import { render } from "./index.vue?vue&type=template&id=f8e8e9c2&ts=true"
import script from "./index.vue?vue&type=script&lang=tsx"
export * from "./index.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__